// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@charset \"UTF-8\";\n\n/** 存放自定义的变量，可全局直接使用 */\n\n/** 主题色 */\n\n/** 字体样式 */\n\n/** 边框样式 */\n\n/** 错误样式 */\n\n/** 警告样式 */\n\n/** 可复用的模块化样式 */\n\n/**\n * 设置多行文本超出隐藏\n * $n 为规定多少行\n*/\n.modules-wrap[data-v-07b3067e] {\n  flex: 1;\n  overflow: hidden;\n}\n.modules-wrap .title[data-v-07b3067e] {\n  padding-bottom: 0.078125rem;\n  font-size: 0.09375rem;\n  font-weight: 550;\n}\n.modules-wrap .table[data-v-07b3067e] {\n  height: calc(100% - 0.260417rem);\n}", ""]);
// Exports
module.exports = exports;
